import classes from './BookingOverview.module.css'

import { bookingActions } from '../../store/booking-slice'
import { useDispatch, useSelector } from 'react-redux'

import { GetDay } from '../UI/Helper'

import DateSummary from './DateSummary'
import GuestRoomSummary from './GuestRoomSummary'

import AdditionalRequest from './AdditionalRequest'
//import AccommodationPref from './AccommodationPref'

import Button from '../UI/Button'

const BookingOverview = () => {
  const dispatch = useDispatch()

  const checkInDate = useSelector((state) => state.booking.checkInDate)
  const checkOutDate = useSelector((state) => state.booking.checkOutDate)

  const checkInDateFormatted = checkInDate
  const checkOutDateFormatted = checkOutDate

  const checkInDayofWeek = GetDay(checkInDate)
  const checkOutDayofWeek = GetDay(checkOutDate)

  const totalGuests = useSelector((state) => state.booking.totalGuests)
  const totalRooms = useSelector((state) => state.booking.totalRooms)

  const checkRatesClickHandler = () => {
    dispatch(bookingActions.toggleDatesConfirmed())
  }

  return (
    <div className={classes.formContainer}>
      <div className={classes.summaryContainer}>
        <div>
          <DateSummary
            checkInWeekday={checkInDayofWeek}
            checkInDate={checkInDateFormatted}
            checkOutWeekday={checkOutDayofWeek}
            checkOutDate={checkOutDateFormatted}
          />
          <GuestRoomSummary guestNum={totalGuests} roomNum={totalRooms} />
        </div>
      </div>
      <div className={classes.changeDetailsButtonContainer}>
        <Button onClick={checkRatesClickHandler} buttonText="Change" />
        <AdditionalRequest />
      </div>
    </div>
  )
}

export default BookingOverview
